module.exports = __webpack_public_path__ + "img/handwritten_icon_hov_pre.8959d43f.png";